import React,{ useContext, useState } from 'react'
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';

import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LoginDialogue from '../Dialogues/LoginDialogue';
import { UserContext } from '../../Context/ContextProvider';
import Profile from './Profile';
import { rgbToHex } from '@mui/material';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
const Menu = () => {
  const [loginDialogue, setLoginDialogue] = useState(false);

  const [loginOrSignup, setLoginOrSignup] = useState('login');
  const {user, setUser} = useContext(UserContext);

  const {cartItems}=useSelector(state=>state.cart);

  const openLoginDialogue = () => setLoginDialogue(true);
  const closeLoginDialogue = () => {
    setLoginDialogue(false);
    setLoginOrSignup('login');
    console.log('here');
    console.log('context state: '+user);
  }
  return (
    <>
      <div className="menu text-[20px] space-x-6 items-center flex flex-col space-y-10 md:flex-row md:space-y-0">
        <div className='tracking-tighter cursor-pointer hover:text-slate-500'>Sell your products</div>
        <Link to='/cart'>
          <div className='cursor-pointer hover:text-slate-500 flex items-center'>
              <ShoppingCartIcon style={{color:'#d64089'}}/>
              <div>Cart</div>
              {user && cartItems && <div className='text-[15px] bg-purple-300 px-[4px] mx-[2px] rounded-[50%]'>{cartItems.length}</div>}
              
          </div>
        </Link>
        <div className='cursor-pointer hover:text-slate-500'>More</div>
        {
          user?
          <Profile user={user} setUser={setUser}/>
          :
          <div className='cursor-pointer hover:text-slate-500  px-[20px] py-[12px] rounded-lg md:bg-gradient-to-r md:from-purple-300' onClick={openLoginDialogue}>Login</div>
        }
      </div>

      <Modal open={loginDialogue} onClose={closeLoginDialogue}  center>
        <LoginDialogue closeLoginDialogue={closeLoginDialogue} />
      </Modal>
    </>
  )
}

export default Menu
